module.exports = __webpack_public_path__ + "static/media/kafka-icon.2d0f3f9a.svg";